import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { environment } from 'src/environments/environment';
import { BisualSettingService } from '../services/bisual-setting.service';
import { PlatformService, isDesktopWebAllowedUrl, shouldForceDesktopApp, toAppRelativeUrl } from '../services/platform.service';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class ForceDesktopAppGuard {
  private readonly router = inject(Router);
  private readonly user_service = inject(UserService);
  private readonly platform = inject(PlatformService);
  private readonly bisual_setting = inject(BisualSettingService);

  canActivateChild(_childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.check(state.url);
  }

  private check(url: string): boolean | UrlTree {
    const user = this.user_service.getCurrentUser();
    const force_employees_to_use_desktop_app = this.bisual_setting.get('force-employees-to-use-desktop-app')?.value === 'true';

    if (
      !shouldForceDesktopApp(
        user,
        force_employees_to_use_desktop_app,
        this.platform.isElectronApp(),
        this.platform.isDesktop(),
        environment.environment
      )
    ) {
      return true;
    }

    if (isDesktopWebAllowedUrl(url)) {
      return true;
    }

    return this.router.createUrlTree(['/employees/use-desktop-app'], {
      // Keep ?selectedIssue=… and other query params for the Electron deep link.
      queryParams: { returnUrl: toAppRelativeUrl(url) },
    });
  }
}
